import { CHART_INTERVAL } from '../chartConfigurationsV2'

const INTERVAL_MS = {
  [CHART_INTERVAL.MINUTE]: 60 * 1000,
  [CHART_INTERVAL.HOUR]: 60 * 60 * 1000,
  [CHART_INTERVAL.DAY]: 24 * 60 * 60 * 1000,
  [CHART_INTERVAL.WEEK]: 7 * 24 * 60 * 60 * 1000,
  [CHART_INTERVAL.MONTH]: 30 * 24 * 60 * 60 * 1000,
  [CHART_INTERVAL.YEAR]: 365 * 24 * 60 * 60 * 1000
}

const intervalToMs = ({ quantity, value }) => {
  const baseMS = INTERVAL_MS[value] || INTERVAL_MS[CHART_INTERVAL.MINUTE]
  return quantity * baseMS
}

const timeRangeToMs = (timeRange) => {
  const start = new Date(timeRange.start)
  const end = new Date(timeRange.end)
  return end - start
}

export const BLOCK = 'BLOCK'
export const WARN = 'WARN'

export const CHART_RENDER_RULESET = [
  {
    id: "interval_1d_timeRange_3mo",
    action: BLOCK,
    message: "Choose ≥ 1-day interval or < 3-month range.",
    condition: ({ interval, timeRange }) => 
      intervalToMs(interval) < INTERVAL_MS[CHART_INTERVAL.DAY] && timeRangeToMs(timeRange) > (3*INTERVAL_MS[CHART_INTERVAL.MONTH]),
  },
  {
    id: "interval_1h_timeRange_3w",
    action: BLOCK,
    message: "Choose ≥ 1-hour interval or < 3-week range.",
    condition: ({ interval, timeRange }) =>
      intervalToMs(interval) < INTERVAL_MS[CHART_INTERVAL.HOUR] && timeRangeToMs(timeRange) > (3*INTERVAL_MS[CHART_INTERVAL.WEEK]),
  },
  {
    id: "interval_1m_timeRange_3d",
    action: BLOCK,
    message: "Choose ≥ 1-min interval or < 3-day range.",
    condition: ({ interval, timeRange }) =>
      intervalToMs(interval) < INTERVAL_MS[CHART_INTERVAL.MINUTE] && timeRangeToMs(timeRange) > (3*INTERVAL_MS[CHART_INTERVAL.DAY]),
  },
  {
    id: "too_many_streams",
    action: WARN,
    message: "Displaying many streams; consider ≤ 3 to keep charts fast.",
    condition: ({ streamCount }) => streamCount > 3,
  },
  {
    id: "intensive_streams_limit",
    action: WARN,
    message: "Limit heavy streams to 2 for better performance.",
    condition: ({ intensiveStreamCount }) => intensiveStreamCount > 2,
  },
  {
    id: "fields_per_stream",
    action: BLOCK,
    message: "Reduce fields per stream to ≤ 3.",
    condition: ({ fieldsPerStream }) => fieldsPerStream > 3,
  },
  // {
  //   id: "too_many_options",
  //   action: BLOCK,
  //   message: "Too many options—select ≤ 10.",
  //   condition: ({ totalOptions }) => totalOptions > 10,
  // },
  // {
  //   id: "query_complexity",
  //   action: BLOCK,
  //   message: "Query too complex — simplify filters, metrics, interval, or grouping.",
  //   condition: ({ complexityScore }) => complexityScore > 100,
  // },
  {
    id: "group_by_count",
    action: WARN,
    message: "Multiple group-bys increase query cost.",
    condition: ({ groupByCount }) => groupByCount > 2,
  },
  {
    id: "expected_points",
    action: BLOCK,
    message: "Result set too large (> 5k points); widen interval or cut range.",
    condition: ({timeRange, interval, streamCount}) =>
      (timeRangeToMs(timeRange) / intervalToMs(interval)) * streamCount > 5000,
  }
]

